
import './App.css';
import { Provider, useDispatch } from 'react-redux';
import { store } from './redux/store';
import Routing from './Routing/Routing';
import { utility } from './helpers/loader';
import { useHistory } from 'react-router-dom';

function App() {

  utility.dispatch = useDispatch()
  utility.useHistory = useHistory()

  return (
    <Routing />
  );
}

export default App;
